import { render, staticRenderFns } from "./CellRendererApplicationNote.vue?vue&type=template&id=596c8877"
import script from "./CellRendererApplicationNote.vue?vue&type=script&lang=js"
export * from "./CellRendererApplicationNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports